export default function BoxSkeletonLoader({ height = "20" }: { height?: string }) {
    return <div className={`flex w-full h-${height} rounded-sm bg-gray-300 animate-pulse`}>
    </div>
}